document.addEventListener('DOMContentLoaded', function() {
    const labels = document.querySelectorAll('.wc-bookings-date-picker-date-fields label');
    if (labels.length >= 2) {
        const firstLabel = labels[0];
        const secondLabel = labels[1];
        const slashNode = firstLabel.nextSibling; // Assuming the "/" is a text node immediately after the first label
        secondLabel.parentNode.insertBefore(firstLabel, secondLabel.nextSibling);
        if (slashNode && slashNode.nodeType === Node.TEXT_NODE && slashNode.nodeValue.trim() === "/") {
            secondLabel.parentNode.insertBefore(slashNode, secondLabel.nextSibling);
        }
    }
});


const topMenu = document.getElementById('top-menu');
const wpMenuCartLi = document.getElementById('wpmenucartli');

if (topMenu && wpMenuCartLi) {
    const firstChild = topMenu.firstElementChild;
    if (firstChild) {
        topMenu.insertBefore(wpMenuCartLi, firstChild.nextSibling);
    } else {
        topMenu.appendChild(wpMenuCartLi);
    }
}




document.addEventListener('DOMContentLoaded', function() {
    const gformFields1 = document.getElementById('gform_fields_1');
    if (gformFields1) {
        const field_1_3 = document.getElementById('field_1_3');
        const field_1_4 = document.getElementById('field_1_4');
        const field_1_5 = document.getElementById('field_1_5');
        const field_1_6 = document.getElementById('field_1_6');
        const field_1_7 = document.getElementById('field_1_7');
        
        if (field_1_3 && field_1_5 && field_1_6) {
            const newRow = document.createElement('div');
            newRow.className = 'row';
            
            const col1 = document.createElement('div');
            col1.className = 'col-md-6 gfmc-column';
            
            const col2 = document.createElement('div');
            col2.className = 'col-md-6';
            
            // Move field_1_6 into col1
            col1.appendChild(field_1_3);
            col1.appendChild(field_1_5);
            col1.appendChild(field_1_6);
            
            // Move field_1_7 into col2
            col2.appendChild(field_1_7);
            
            // Append columns to the new row
            newRow.appendChild(col1);
            newRow.appendChild(col2);
            
            // Append the new row to gformFields1
            gformFields1.appendChild(newRow);
        }
    }
});


jQuery(document).on("em_booking_complete", function(event, response) {
    console.log("Booking complete event triggered");

    // Optional: check for success before redirecting
    if ((response && response.result) || response.success) {
        console.log("Redirecting to review booking...");
        window.location.href = "/review-booking/";
    } else {
        console.warn("Booking failed or response format unexpected");
    }
});


